export enum ChecklistTemplateEntryConditionMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT'
}

export enum ChecklistTemplateEntryConditionDropdownEntryType {
  ENTRY = 'ENTRY',
  OPTION = 'OPTION',
  ASSESSMENT = 'ASSESSMENT',
  RANGE = 'RANGE'
}
